import React from "react";
import { Typography } from "@mui/material";
import { ContactSupport as SupportIcon } from "@mui/icons-material";
import PageContentLayout from "../components/layout/PageContentLayout";

const Support = () => {
  return (
    <PageContentLayout
      title="Support Tickets"
      subtitle="Manage customer support tickets and issues"
      breadcrumbs={[
        { label: "Support Tickets", icon: <SupportIcon sx={{ color: "#ffffff", fontSize: 18 }} /> },
      ]}
      backTo="/dashboard"
    >
      <Typography variant="body1" sx={{ textAlign: "center", py: 8, color: "text.secondary" }}>
        Support ticket management system coming soon...
      </Typography>
    </PageContentLayout>
  );
};

export default Support;
